import { fetchEndpointData } from '@utils/fetchEndpointData';

import type { BodyType as UpdateMeBodyType, ResponseType as UpdateMeResponseType } from './endpoints/UpdateMeEndpoint';
import type { UpdateUserSupplierBody, UpdateUserSupplierResponse } from './endpoints/UpdateUserSupplierEndpoint.types';
import type {
  UpdateCustomerUserRoleBody,
  UpdateCustomerUserRoleResponse,
} from './endpoints/UpdateCustomerUserRoleEndpoint.types';
import type { ListInternalUsersResponse, InternalUser } from './endpoints/ListInternalUsersEndpoint.types';
import type { GetInternalUserResponse } from './endpoints/GetInternalUserEndpoint.types';
import type { CreateInternalUserBody, CreateInternalUserResponse } from './endpoints/CreateInternalUserEndpoint.types';
import type { UpdateInternalUserBody, UpdateInternalUserResponse } from './endpoints/UpdateInternalUserEndpoint.types';

export type { InternalUser };

export async function updateMyProfile(body: UpdateMeBodyType) {
  const response = await fetchEndpointData<UpdateMeResponseType>(`/api/v1/user/me`, {
    method: 'PATCH',
    body,
  });
  return response;
}

export async function updateUserSupplier(
  userSupplierId: number,
  body: UpdateUserSupplierBody,
): Promise<UpdateUserSupplierResponse> {
  return fetchEndpointData<UpdateUserSupplierResponse>(`/api/v1/user-suppliers/${userSupplierId}`, {
    method: 'PATCH',
    body,
  });
}

export async function updateCustomerUserRole(
  userId: string,
  customerId: number,
  role: string,
): Promise<UpdateCustomerUserRoleResponse> {
  const body: UpdateCustomerUserRoleBody = {
    customerId,
    role: role as 'CustomerAdmin' | 'CustomerUser',
  };
  return fetchEndpointData<UpdateCustomerUserRoleResponse>(`/api/v1/users/${userId}/customer-role`, {
    method: 'POST',
    body,
  });
}

export async function listInternalUsers(params?: {
  cursor?: string;
  take?: number;
  search?: string;
  isActive?: boolean;
}): Promise<ListInternalUsersResponse> {
  const query = new URLSearchParams();
  if (params?.cursor) query.set('cursor', params.cursor);
  if (params?.take != null) query.set('take', params.take.toString());
  if (params?.search) query.set('search', params.search);
  if (params?.isActive != null) query.set('isActive', params.isActive.toString());
  const qs = query.toString();
  return fetchEndpointData<ListInternalUsersResponse>(`/api/v1/users${qs ? `?${qs}` : ''}`);
}

export async function getInternalUser(userId: string): Promise<GetInternalUserResponse> {
  return fetchEndpointData<GetInternalUserResponse>(`/api/v1/users/${userId}`);
}

export async function createInternalUser(body: CreateInternalUserBody): Promise<CreateInternalUserResponse> {
  return fetchEndpointData<CreateInternalUserResponse>(`/api/v1/users`, {
    method: 'POST',
    body,
  });
}

export async function updateInternalUser(
  userId: string,
  body: UpdateInternalUserBody,
): Promise<UpdateInternalUserResponse> {
  return fetchEndpointData<UpdateInternalUserResponse>(`/api/v1/users/${userId}`, {
    method: 'PATCH',
    body,
  });
}
